import Plugins from './Plugins';

export default {
  title: 'Plugins',
  path: '/plugins',
  component: Plugins,
  rootPath: { name: 'Plugins' },
};
